import React from 'react';
import '../Section10/component.css';

const Section35 = () => {
  return (
    <div className="svc-intro">
      <div className="svc-intro-inner">
        <span className="svc-label">Marketing</span>
        <h2 className="svc-intro-title">Your Expert Partner in Social Media Marketing</h2>
        <p className="svc-intro-body">
          At Hypertonic IT Solutions, we specialize in crafting strategic, impactful, and results-driven social media marketing campaigns across all major platforms. With our team of experienced marketers and content creators, we are dedicated to elevating your brand's online presence and driving meaningful engagement that aligns with your business goals.
        </p>

        <div className="svc-details">
          <h3 className="svc-intro-title" style={{ fontSize: '28px', marginTop: '60px' }}>Why Choose Hypertonic</h3>

          <div className="svc-feature">
            <h4>Expertise:</h4>
            <p className="svc-intro-body">With years of experience in social media marketing, our team possesses the knowledge and creative skills to develop campaigns that stand out in the crowded social media landscape. We stay ahead of trends to ensure your brand remains relevant and engaging.</p>
          </div>

          <div className="svc-feature">
            <h4>Multi-Platform Strategy:</h4>
            <p className="svc-intro-body">We understand the importance of a broad reach, which is why we develop and implement strategies tailored to each social media platform, including Facebook, Instagram, Twitter, LinkedIn, and more. Our goal is to maximize your brand's visibility across all channels.</p>
          </div>

          <div className="svc-feature">
            <h4>Tailored Campaigns:</h4>
            <p className="svc-intro-body">We believe in creating custom social media strategies that align with your unique business objectives. Whether you're a startup looking to build brand awareness or an established company aiming to increase conversions, we work closely with you to deliver campaigns that meet your specific needs.</p>
          </div>

          <h3 className="svc-intro-title" style={{ fontSize: '28px', marginTop: '60px' }}>Our Social Media Marketing Services Include:</h3>

          <div className="svc-feature">
            <h4>Social Media Strategy Development:</h4>
            <p className="svc-intro-body">We create comprehensive social media strategies that align with your business goals, focusing on content planning, audience targeting, and platform optimization to maximize results.</p>
          </div>

          <div className="svc-feature">
            <h4>Content Creation & Curation:</h4>
            <p className="svc-intro-body">From graphics and videos to blog posts and infographics, our team produces high-quality content designed to engage your audience and drive meaningful interactions.</p>
          </div>

          <div className="svc-feature">
            <h4>Social Media Advertising:</h4>
            <p className="svc-intro-body">We specialize in creating and managing targeted social media ad campaigns that drive traffic, increase brand awareness, and generate leads. Our data-driven approach ensures that your ad spend is optimized for maximum ROI.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section35;
